module.exports = __webpack_public_path__ + "img/day19.ffc9f11a.svg";